<template>
    <div>
        <pagination-component
            :pagination="pagination"
            :key="'pagination-1-'+ (pagination.current_page ? pagination.current_page : 1) + pagination.total"
        ></pagination-component>
        <table class="table simple-table table-striped table-sm mb-0 table-bordered" style="font-size:0.8em;">
            <thead class="thead-dark">
            <tr>
                <th class="report-record" scope="col">{{$lang('ID')}}</th>
                <th class="report-record" scope="col">{{$lang('Nr zadania')}}</th>
                <th class="report-record" scope="col" style="min-width: 100px">{{$lang('Data zgłoszenia')}}</th>
                <th class="report-record" scope="col" style="min-width: 100px">{{$lang('Ostatnia ocena')}}</th>
                <th class="report-record" scope="col">{{$lang('Ostatni komentarz')}}</th>
                <th class="report-record" scope="col">{{$lang('Temat')}}</th>
                <th class="report-record" scope="col">{{$lang('Status')}}</th>
                <th class="report-record" scope="col">{{$lang('Osoba oceniająca')}}</th>
                <th class="report-record" scope="col">{{$lang('Zgłaszający')}}</th>
                <th class="report-record" scope="col">{{$lang('Biblioteka')}}</th>
            </tr>
            </thead>
            <tbody>

            <tr v-if="pagination.total === 0" class="table-light">
                <th colspan="10">{{$lang('Brak zgłoszeń.')}}</th>
            </tr>

            <tr v-else v-for="task in pagination.data">
                <td class="report-record" :data-title="$lang('ID')">
                    <a :href="'/task/' + task.id">{{task.id}}</a>
                </td>
                <td class="report-record" :data-title="$lang('Nr zadania')">
                    <a :href="jira_link + task.jira_id" target="_blank" v-if="task.jira_id"> {{task.jira_id}} </a>
                    <a v-else-if="task.ptd_id" :href="ptd_link + task.ptd_id" target="_blank">{{task.ptd_id}}</a>
                    <span v-else> - </span>
                </td>
                <td class="report-record"
                    :data-title="$lang('Data')">{{task.created_at_showable}}
                </td>
                <td class="report-record"
                    :data-title="$lang('Ostatnia ocena')">{{task.lastMarkDate_showable}}
                </td>
                <td class="report-record"
                    :data-title="$lang('Ostatni komentarz')">{{task.lastCommentDate_showable}}
                </td>
                <td style="text-align: left" class="report-record" :data-title="$lang('Temat')">{{task.subject_alternative}}</td>
                <td class="report-record" :data-title="$lang('Status')">
                    <span :class="'badge badge-'+project_badge_prefix+task.status">{{task.statusName}}</span>
                </td>
                <td style="text-align: left" class="report-record" :data-title="$lang('Osoba oceniająca')">
                    {{task.consultantFullName}}
                </td>
                <td style="text-align: left" class="report-record" :data-title="$lang('Zgłaszający')">
                    {{task.personName + ' ' + task.personSurname}}
                </td>
                <td style="text-align: left" class="report-record" :data-title="$lang('Biblioteka')">
                    {{task.libraryName}}
                </td>
            </tr>

            </tbody>
        </table>
        <pagination-component
            :pagination="pagination"
            :key="'pagination-2-'+ (pagination.current_page ? pagination.current_page : 1) + pagination.total"
        ></pagination-component>
    </div>
</template>

<script>
    export default {
        name: 'consultants-and-system-engineers-table',
        props: ['pagination', 'jira_link', 'ptd_link', 'project_badge_prefix']
    }
</script>
